import { SecureAction } from '../secure-action';

export class DataConversionSecureAction extends SecureAction {
  public static readonly VIEW: SecureAction = new DataConversionSecureAction('admin:data_conversion|view');
  private constructor(name: string) {
    super(name);
  }
}
